import { useState } from 'react';
import Modal from '@/components/base/Modal';
import { useApp } from '@/context/AppContext';
import { useData } from '@/context/DataContext';
import { supabase, FILES_BUCKET } from '@/lib/supabase';
import { tableFor } from '@/lib/tables';

export default function DeleteConfirm() {
  const { deleteTarget, closeDelete, showToast } = useApp();
  const { refresh } = useData();
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!deleteTarget) return;
    setBusy(true);
    const table = tableFor(deleteTarget.type);

    let storagePath: string | null = null;
    if (deleteTarget.type === 'file') {
      const { data } = await supabase.from(table).select('storage_path').eq('id', deleteTarget.id).maybeSingle();
      storagePath = (data?.storage_path as string) || null;
    }

    const { error } = await supabase.from(table).delete().eq('id', deleteTarget.id);
    if (!error && storagePath) {
      await supabase.storage.from(FILES_BUCKET).remove([storagePath]);
    }
    setBusy(false);
    if (error) {
      showToast('Silinemedi: ' + error.message);
    } else {
      showToast('Kayıt silindi');
      closeDelete();
      refresh();
    }
  };

  return (
    <Modal open={Boolean(deleteTarget)} onClose={closeDelete} title="Kaydı Sil" size="sm">
      <div className="space-y-4">
        <div className="flex items-start gap-3 rounded-md bg-accent-100/60 p-4">
          <i className="ri-error-warning-line text-xl text-accent-700" />
          <p className="text-sm text-foreground-700">
            <span className="font-semibold text-foreground-900">{deleteTarget?.label}</span> kalıcı olarak silinecek.
            Bu işlem geri alınamaz.
          </p>
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={closeDelete}
            disabled={busy}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Vazgeç
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={busy}
            className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Evet, Sil
          </button>
        </div>
      </div>
    </Modal>
  );
}